import React, { useState, useEffect, useRef } from "react";
import {
  Typography,
  Card,
  CardContent,
  MenuItem,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormGroup,
  RadioGroup,
  Radio,
  Button,
  useMediaQuery,
  Checkbox,
} from "@mui/material";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import judete from "./constants/judete";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { CloudUpload } from "@mui/icons-material";
import dayjs from "dayjs";
import axios from "axios";
import { useTheme } from "@mui/material/styles";
import SuccessMessage from "./SuccessMessage";

const generateCaptchaText = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let captcha = "";
  for (let i = 0; i < 6; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    captcha += characters.charAt(randomIndex);
  }
  return captcha;
};

const Autocitiri = () => {
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaText, setCaptchaText] = useState(generateCaptchaText());
  const canvasRef = useRef(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [selectedCountyObject, setSelectedCountyObject] = useState(null);
  const [formData, setFormData] = useState({
    contractType: "clientCasnic",
    county: "",
    POD: "",
    Serie: "",
    DataCitirii: "",
    Registru180: false,
    Registru181: false,
    Registru182: false,
    Registru580: false,
    Registru880: false,
    Registru280: false,
    Index180: "0",
    Index280: "0",
    Index181: "0",
    Index182: "0",
    Index580: "0",
    Index880: "0",
    Photo: null,
    Email: null,
    Consent: false,
  });

  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:600px)");

  const handleFormSubmit = () => {
    if (
      isFormValid() &&
      isCaptchaValid() &&
      isEmailValid() &&
      formData.Consent
    ) {
      const apiUrl = "https://autocitiri.distributie-energie.ro/api/auto/add";
      const form = new FormData();

      const dataCitiriiDate = new Date(formData.DataCitirii).toISOString();

      form.append(
        "POD",
        selectedCountyObject.POD.toString() + formData.POD.toString()
      );
      form.append("Serie", formData.Serie);
      form.append("DataCitirii", dataCitiriiDate);
      form.append("Registru180", formData.Registru180);
      form.append("Registru181", formData.Registru181);
      form.append("Registru182", formData.Registru182);
      form.append("Registru580", formData.Registru580);
      form.append("Registru880", formData.Registru880);
      form.append("Registru280", formData.Registru280);
      form.append("Index180", formData.Index180);
      form.append("Index280", formData.Index280);
      form.append("Index181", formData.Index181);
      form.append("Index182", formData.Index182);
      form.append("Index580", formData.Index580);
      form.append("Index880", formData.Index880);
      form.append("Photo", formData.Photo);
      form.append("Email", formData.Email);

      axios
        .post(apiUrl, form)
        .then(function (response) {
          setFormSubmitted(true);
          console.log(response);
          alert("Autocitirea a fost transmisa cu succes!");
          setFormData({
            contractType: "",
            county: "",
            POD: "",
            Serie: "",
            DataCitirii: "",
            Registru180: false,
            Registru181: false,
            Registru182: false,
            Registru580: false,
            Registru880: false,
            Registru280: false,
            Index180: "0",
            Index280: "0",
            Index181: "0",
            Index182: "0",
            Index580: "0",
            Index880: "0",
            Photo: null,
            Email: null,
            Consent: false,
          });
        })
        .catch(function (error) {
          console.error(error);
          alert("Intampinam dificultati. Va rugam sa incercati mai tarziu");
        });
    } else {
      if (!isCaptchaValid()) {
        alert("CAPTCHA incorect. Va rugam sa mai incercati.");
      }
      if (!isEmailValid()) {
        alert("Adresa de email este incorecta. Va rugam sa mai incercati.");
      }
      if (!formData.Consent) {
        alert(
          "Pentru a putea transmite datele, va rugam sa bifati acordul pentru preluarea datelor cu caracter personal"
        );
      }
      if (!formData.Email) {
        alert(
          "Pentru a putea transmite datele, va rugam sa introduceti o adresa de email corecta"
        );
      }
    }
  };

  const handleFormChange = (e) => {
    const { name, value, type, files } = e.target;

    setFormSubmitted(false);

    if (type === "file") {
      const file = files[0];
      if (file) {
        if (
          file.type === "image/jpeg" ||
          (file.type === "image/jpg" && file.size <= 3 * 1024 * 1024)
        ) {
          setFormData((prevData) => ({
            ...prevData,
            [name]: file,
          }));
        } else {
          alert("Please select a JPG file no larger than 3MB.");
          e.target.value = null;
        }
      } else {
        setFormData((prevData) => ({
          ...prevData,
          [name]: null,
        }));
      }
    } else {
      if (name.startsWith("Index")) {
        const registruName = `Registru${name.substr(5)}`;

        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
          [registruName]: true,
        }));
      } else if (name === "Consent") {
        setFormData((prevData) => ({
          ...prevData,
          [name]: e.target.checked,
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
    }
  };

  const currentDate = dayjs();
  const isMonthBeforeCurrent = (month) => {
    const currentMonth = currentDate.startOf("month");
    return dayjs(month).isBefore(currentMonth, "month");
  };

  const handleDateChange = (date) => {
    const formattedDate = dayjs(date).format("YYYY-MM-DD");

    setFormData((prevData) => ({
      ...prevData,
      DataCitirii: formattedDate,
    }));
  };

  const handleCountyChange = (e) => {
    const selectedCounty = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      county: selectedCounty,
    }));

    const countyObject = judete.find((j) => j.name === selectedCounty);
    setSelectedCountyObject(countyObject);
  };

  const handleOptionChange = (event) => {
    const selectedOption = event.target.value;
    setFormData((prevData) => ({
      ...prevData,
      contractType: selectedOption,
    }));

    setFormSubmitted(false);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      if (file.type === "image/jpeg" && file.size <= 3 * 1024 * 1024) {
        setFormData((prevData) => ({
          ...prevData,
          Photo: file,
        }));
      } else {
        alert("Please select a JPG file no larger than 3MB.");
        e.target.value = null;
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        Photo: null,
      }));
    }
  };

  useEffect(() => {
    const initialCaptchaText = generateCaptchaText();
    setCaptchaText(initialCaptchaText);

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.font = "30px Arial";
    ctx.fillStyle = "#333";

    const applyCharacterDistortion = (charX, charY, char) => {
      const offsetX = Math.random() * 4 - 2;
      const offsetY = Math.random() * 4 - 2;
      ctx.save();
      ctx.setTransform(1, 0, 0, 1, offsetX, offsetY);
      ctx.fillText(char, charX, charY);
      ctx.restore();
    };

    const charWidth = ctx.measureText("A").width;
    for (let i = 0; i < captchaText.length; i++) {
      const charX = 25 + i * charWidth;
      const charY = 40;
      applyCharacterDistortion(charX, charY, captchaText.charAt(i));
    }

    const addNoise = (ctx, width, height, density) => {
      for (let i = 0; i < width * height * density; i++) {
        const x = Math.random() * width;
        const y = Math.random() * height;
        const radius = Math.random() * 1; // Increase noise particle size
        const noiseColor = `rgba(0, 0, 0, ${Math.random() * 0.5})`; // Randomized transparency
        ctx.fillStyle = noiseColor;
        ctx.beginPath();
        ctx.arc(x, y, radius, 0, Math.PI * 2);
        ctx.fill();
      }
    };

    addNoise(ctx, canvas.width, canvas.height, 0.5); // Increase density for more noise
  }, []);

  const refreshCaptcha = () => {
    const newCaptchaText = generateCaptchaText();
    const textFillColor = "#333";

    setCaptchaText(newCaptchaText);

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.font = "30px Arial";
    ctx.fillStyle = "#333";

    const applyCharacterDistortion = (charX, charY, char) => {
      const offsetX = Math.random() * 4 - 2;
      const offsetY = Math.random() * 4 - 2;
      ctx.save();
      ctx.setTransform(1, 0, 0, 1, offsetX, offsetY);
      ctx.fillText(char, charX, charY);
      ctx.restore();
    };

    const addNoise = (ctx, width, height, density) => {
      for (let i = 0; i < width * height * density; i++) {
        const x = Math.random() * width;
        const y = Math.random() * height;
        const radius = Math.random() * 1; // Increase noise particle size
        const alpha = Math.random() * 0.8; // Lower alpha for darker noise
        const noiseColor = `rgba(0, 0, 0, ${alpha})`;
        ctx.fillStyle = noiseColor;
        ctx.beginPath();
        ctx.arc(x, y, radius, 0, Math.PI * 2);
        ctx.fill();
      }
    };

    addNoise(ctx, canvas.width, canvas.height, 0.5); // Increase density for more noise

    const charWidth = 30;
    for (let i = 0; i < newCaptchaText.length; i++) {
      const charX = 25 + i * charWidth;
      const charY = 40;
      const offsetX = Math.random() * 4 - 2;
      const offsetY = Math.random() * 4 - 2;

      ctx.save();
      ctx.setTransform(1, 0, 0, 1, offsetX, offsetY);
      ctx.fillStyle = textFillColor;
      ctx.fillText(newCaptchaText.charAt(i), charX, charY);
      ctx.restore();
    }
  };

  const isCaptchaValid = () => {
    return captchaInput.toLowerCase() === captchaText.toLowerCase();
  };

  const isEmailValid = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (
      formData.Email &&
      formData.Email.length > 0 &&
      formData.Email.length < 100
    ) {
      return emailRegex.test(formData.Email);
    } else if (formData.Email && formData.Email.length > 100) {
      return false;
    } else {
      return true;
    }
  };

  const isFormValid = () => {
    if (
      formData.contractType &&
      formData.county &&
      formData.POD &&
      formData.Serie &&
      formData.DataCitirii &&
      formData.Index180 &&
      formData.Index181 &&
      formData.Index182 &&
      formData.Index580 &&
      formData.Index880 &&
      formData.Photo &&
      formData.Email &&
      formData.Consent
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div>
      {formSubmitted ? (
        <SuccessMessage />
      ) : (
        <>
          <a
            href="https://www.distributie-energie.ro/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              style={{
                height: isMobile ? "60px" : "80px",
                marginBottom: isMobile ? "10px" : "",
              }}
              src="/siglaDEER.png"
              alt="siglaDEER"
            />
          </a>

          <Typography
            variant="h5"
            gutterBottom
            sx={{
              textAlign: "center",
              mt: 2,
              fontWeight: "bold",
              color: "#29348f",
              fontSize: "1.5rem",
              mx: 2,
            }}
          >
            Citiri contoare
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            sx={{ textAlign: "center", mx: 2 }}
          >
            Pentru a transmite datele dumneavoastră, vă rugăm să completați:
          </Typography>
          <div style={{ textAlign: "-webkit-center" }}>
            <Card
              elevation={11}
              sx={{ width: isMobile ? "100%" : "60%", mt: 2 }}
            >
              <CardContent>
                <Typography
                  variant="body1"
                  sx={{ mt: 2, mb: 1, fontWeight: "bold", color: "#29348f" }}
                >
                  Pasul 1: Date identificare LOC DE CONSUM
                </Typography>
                <div style={{ flexDirection: "column" }}>
                  <FormControl sx={{ width: "70%", mt: 2 }}>
                    <TextField
                      sx={{ mb: 3 }}
                      required
                      select
                      label="Judet"
                      name="county"
                      value={formData.county}
                      onChange={handleCountyChange}
                      error={formSubmitted && !formData.county}
                    >
                      {judete.map((j) => (
                        <MenuItem key={j.name} value={j.name}>
                          {j.name}
                        </MenuItem>
                      ))}
                    </TextField>

                    <div style={{ display: "flex" }}>
                      <TextField
                        required
                        sx={{ flex: 1 }}
                        label="POD"
                        variant="outlined"
                        name="POD"
                        value={
                          selectedCountyObject && selectedCountyObject.POD
                            ? selectedCountyObject.POD + (formData.POD || "")
                            : ""
                        }
                        onChange={(e) => {
                          // Extract the non-editable and editable parts
                          const value = e.target.value;
                          const nonEditablePart =
                            selectedCountyObject.POD.toString();
                          const editablePart = value.slice(
                            nonEditablePart.length
                          );

                          // Ensure the non-editable part remains unmodified
                          if (
                            nonEditablePart !==
                            value.slice(0, nonEditablePart.length)
                          ) {
                            e.target.value += editablePart;
                          }

                          // Update the formData with only the editable part
                          setFormData((prevData) => ({
                            ...prevData,
                            POD: editablePart,
                          }));
                        }}
                        error={
                          formSubmitted &&
                          (!formData.POD || !/^\d{7}$/.test(formData.POD))
                        }
                        helperText={
                          formSubmitted &&
                          (!formData.POD || !/^\d{7}$/.test(formData.POD))
                            ? "Trebuie sa adaugi doar ultimele 7 cifre de la finalul POD-ului"
                            : ""
                        }
                        inputProps={{
                          maxLength: 18,
                        }}
                      />
                    </div>

                    <FormHelperText sx={{ color: "orangered" }}>
                      completați ultimele 7 cifre ale POD
                    </FormHelperText>
                    <TextField
                      sx={{ width: "100%" }}
                      label="Serie Contor"
                      variant="outlined"
                      required
                      name="Serie"
                      value={formData.Serie}
                      onChange={handleFormChange}
                      error={
                        formSubmitted &&
                        (!formData.Serie ||
                          formData.Serie.length < 4 ||
                          formData.Serie.length > 20)
                      }
                      inputProps={{ maxLength: 20 }}
                    />
                    <FormHelperText sx={{ color: "orangered" }}>
                      completați seria aflată sub codul de bare de pe contor
                    </FormHelperText>
                    <DatePicker
                      sx={{
                        width: "100%",
                        ...(formSubmitted && !formData.DataCitirii
                          ? {
                              color: "red",
                              borderColor: "red",
                              border: "0.75px solid crimson",
                              borderRadius: "5px",
                            }
                          : {}),
                      }}
                      selected={currentDate.toDate()}
                      onChange={handleDateChange}
                      disableFuture
                      shouldDisableMonth={isMonthBeforeCurrent}
                      format="DD/MM/YYYY"
                    />

                    <FormHelperText sx={{ color: "orangered" }}>
                      completați cu data citirii
                    </FormHelperText>
                  </FormControl>
                  <Typography
                    variant="body1"
                    sx={{ mt: 3, mb: 2, fontWeight: "bold", color: "#29348f" }}
                  >
                    Pasul 2: Alegeți tipul de CONTRACT IN VIGOARE
                  </Typography>
                  <FormControl sx={{ width: "70%" }}>
                    <RadioGroup
                      value={formData.contractType}
                      onChange={handleOptionChange}
                      sx={{ textAlign: "left" }}
                    >
                      <FormControlLabel
                        value="clientCasnic"
                        control={<Radio />}
                        label="Client casnic"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="clientCasnicDiferentiat"
                        control={<Radio />}
                        label="Client casnic cu tarif diferentiat"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="clientNoncasnic"
                        control={<Radio />}
                        label="Client noncasnic sau casnic cu putere mai mare de 30kW"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="clientNoncasnicDiferentiat"
                        control={<Radio />}
                        label="Client noncasnic sau casnic cu putere mai mare de 30kW, cu tarif diferențiat"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="prosumatorClientCasnic"
                        control={<Radio />}
                        label="Prosumator client casnic"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="prosumatorProducatorClientNoncasnic"
                        control={<Radio />}
                        label="Prosumator / producator client noncasnic"
                        labelPlacement="end"
                      />
                    </RadioGroup>
                    <Typography
                      variant="body1"
                      sx={{
                        mt: 3,
                        mb: 2,
                        fontWeight: "bold",
                        color: "#29348f",
                      }}
                    >
                      Pasul 3: Introduceți valorile indexelor curente
                    </Typography>
                    {formData.contractType === "prosumatorClientCasnic" && (
                      <>
                        <TextField
                          sx={{ width: "100%" }}
                          label="INDEX"
                          variant="outlined"
                          value={formData.Index180}
                          required
                          name="Index180"
                          onChange={handleFormChange}
                          error={formSubmitted && !formData.Index180}
                        />
                        <FormHelperText sx={{ color: "orangered" }}>
                          1.8.0 Energie activă (rata unică fără zone orare)
                        </FormHelperText>
                        <TextField
                          sx={{ width: "100%" }}
                          label="INDEX"
                          variant="outlined"
                          value={formData.Index280}
                          required
                          name="Index280"
                          onChange={handleFormChange}
                          error={formSubmitted && !formData.Index280}
                        />
                        <FormHelperText sx={{ color: "orangered" }}>
                          2.8.0 Energie activă livrată de prosumator în rețeaua
                          electrică de distribuție
                        </FormHelperText>
                      </>
                    )}
                    {formData.contractType ===
                      "prosumatorProducatorClientNoncasnic" && (
                      <>
                        <TextField
                          sx={{ width: "100%" }}
                          label="INDEX"
                          variant="outlined"
                          value={formData.Index180}
                          required
                          name="Index180"
                          onChange={handleFormChange}
                          error={formSubmitted && !formData.Index180}
                        />
                        <FormHelperText sx={{ color: "orangered" }}>
                          1.8.0 Energie activă (rata unică fără zone orare)
                        </FormHelperText>
                        <TextField
                          sx={{ width: "100%" }}
                          label="INDEX"
                          variant="outlined"
                          value={formData.Index280}
                          required
                          name="Index280"
                          onChange={handleFormChange}
                          error={formSubmitted && !formData.Index280}
                        />
                        <FormHelperText sx={{ color: "orangered" }}>
                          2.8.0 Energie activă livrată de prosumator în rețeaua
                          electrică de distribuție
                        </FormHelperText>
                        <TextField
                          sx={{ width: "100%" }}
                          label="INDEX"
                          variant="outlined"
                          value={formData.Index580}
                          required
                          name="Index580"
                          onChange={handleFormChange}
                          error={formSubmitted && !formData.Index580}
                        />
                        <FormHelperText sx={{ color: "orangered" }}>
                          5.8.0 Energie reactivă inductivă
                        </FormHelperText>

                        <TextField
                          sx={{ width: "100%" }}
                          label="INDEX"
                          variant="outlined"
                          value={formData.Index880}
                          required
                          name="Index880"
                          onChange={handleFormChange}
                          error={formSubmitted && !formData.Index880}
                        />
                        <FormHelperText sx={{ color: "orangered" }}>
                          8.8.0 Energie reactivă capacitivă
                        </FormHelperText>
                      </>
                    )}
                    {formData.contractType === "clientCasnic" && (
                      <>
                        <TextField
                          sx={{ width: "100%" }}
                          label="INDEX"
                          variant="outlined"
                          value={formData.Index180}
                          required
                          name="Index180"
                          onChange={handleFormChange}
                          error={formSubmitted && !formData.Index180}
                        />
                        <FormHelperText sx={{ color: "orangered" }}>
                          1.8.0 Energie activă (rata unică fără zone orare)
                        </FormHelperText>
                      </>
                    )}
                    {formData.contractType === "clientCasnicDiferentiat" && (
                      <>
                        <TextField
                          sx={{ width: "100%" }}
                          label="INDEX"
                          variant="outlined"
                          value={formData.Index181}
                          required
                          name="Index181"
                          onChange={handleFormChange}
                          error={formSubmitted && !formData.Index181}
                        />
                        <FormHelperText sx={{ color: "orangered" }}>
                          1.8.1 Energie activă noapte (gol)
                        </FormHelperText>
                        <TextField
                          sx={{ width: "100%" }}
                          label="INDEX"
                          variant="outlined"
                          value={formData.Index182}
                          required
                          name="Index182"
                          onChange={handleFormChange}
                          error={formSubmitted && !formData.Index182}
                        />
                        <FormHelperText sx={{ color: "orangered" }}>
                          1.8.2 Energie activă zi (vârf)
                        </FormHelperText>
                      </>
                    )}
                    {formData.contractType === "clientNoncasnic" && (
                      <>
                        <TextField
                          sx={{ width: "100%" }}
                          label="INDEX"
                          variant="outlined"
                          value={formData.Index180}
                          required
                          name="Index180"
                          onChange={handleFormChange}
                          error={formSubmitted && !formData.Index180}
                        />
                        <FormHelperText sx={{ color: "orangered" }}>
                          1.8.0 Energie activă (rata unică fără zone orare)
                        </FormHelperText>
                        <TextField
                          sx={{ width: "100%" }}
                          label="INDEX"
                          variant="outlined"
                          value={formData.Index580}
                          required
                          name="Index580"
                          onChange={handleFormChange}
                          error={formSubmitted && !formData.Index580}
                        />
                        <FormHelperText sx={{ color: "orangered" }}>
                          5.8.0 Energie reactivă inductivă
                        </FormHelperText>

                        <TextField
                          sx={{ width: "100%" }}
                          label="INDEX"
                          variant="outlined"
                          value={formData.Index880}
                          required
                          name="Index880"
                          onChange={handleFormChange}
                          error={formSubmitted && !formData.Index880}
                        />
                        <FormHelperText sx={{ color: "orangered" }}>
                          8.8.0 Energie reactivă capacitivă
                        </FormHelperText>
                      </>
                    )}
                    {formData.contractType === "clientNoncasnicDiferentiat" && (
                      <>
                        <TextField
                          sx={{ width: "100%" }}
                          label="INDEX"
                          variant="outlined"
                          value={formData.Index181}
                          required
                          name="Index181"
                          onChange={handleFormChange}
                          error={formSubmitted && !formData.Index181}
                        />
                        <FormHelperText sx={{ color: "orangered" }}>
                          1.8.1 Energie activă noapte (gol)
                        </FormHelperText>
                        <TextField
                          sx={{ width: "100%" }}
                          label="INDEX"
                          variant="outlined"
                          value={formData.Index182}
                          required
                          name="Index182"
                          onChange={handleFormChange}
                          error={formSubmitted && !formData.Index182}
                        />
                        <FormHelperText sx={{ color: "orangered" }}>
                          1.8.2 Energie activă zi (vârf)
                        </FormHelperText>

                        <TextField
                          sx={{ width: "100%" }}
                          label="INDEX"
                          variant="outlined"
                          value={formData.Index580}
                          required
                          name="Index580"
                          onChange={handleFormChange}
                          error={formSubmitted && !formData.Index580}
                        />
                        <FormHelperText sx={{ color: "orangered" }}>
                          5.8.0 Energie reactivă inductivă
                        </FormHelperText>
                        <TextField
                          sx={{ width: "100%" }}
                          label="INDEX"
                          variant="outlined"
                          value={formData.Index880}
                          required
                          name="Index880"
                          onChange={handleFormChange}
                          error={formSubmitted && !formData.Index880}
                        />
                        <FormHelperText sx={{ color: "orangered" }}>
                          8.8.0 Energie reactivă capacitivă
                        </FormHelperText>
                      </>
                    )}
                    <Typography
                      variant="body1"
                      sx={{
                        mt: 3,
                        mb: 2,
                        fontWeight: "bold",
                        color: "#29348f",
                      }}
                    >
                      Pasul 4: Atașați fotografia indexului
                    </Typography>
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        alignSelf: "center",
                      }}
                    >
                      <input
                        type="file"
                        accept=".jpg"
                        name="Photo"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                        id="fileInput"
                      />
                      <label htmlFor="fileInput">
                        <Button
                          variant="outlined"
                          component="span"
                          startIcon={<CloudUpload />}
                          sx={
                            formSubmitted && !formData.Photo
                              ? { color: "red", borderColor: "red" }
                              : {}
                          }
                        >
                          Incarcati fotografia
                        </Button>
                      </label>
                      <Typography variant="body1" sx={{ ml: 2 }}>
                        {formData.Photo
                          ? `Fisierul selectat: ${formData.Photo.name}`
                          : "Niciun fisier ales"}
                      </Typography>
                    </div>
                    <FormHelperText sx={{ color: "orangered" }}>
                      (se pot incărca doar fișiere in format .jpeg și mai mici
                      de 3 MB)
                    </FormHelperText>
                    <TextField
                      sx={{ width: "100%" }}
                      size="small"
                      label="Adresa de email la care puteți fi contactat"
                      variant="outlined"
                      required
                      name="Email"
                      value={formData.Email}
                      onChange={handleFormChange}
                      error={formData.Email && !isEmailValid()}
                    />
                    <Typography
                      variant="body1"
                      sx={{
                        mt: 3,
                        mb: 1,
                        fontWeight: "bold",
                        color: "#29348f",
                      }}
                    >
                      Pasul 5: Completati CAPTCHA si trimiteti
                    </Typography>
                    <div
                      style={{
                        display: isMobile ? "grid" : "flex",
                        alignItems: "center",
                        marginBottom: 20,
                        marginTop: 10,
                        alignSelf: "center",
                      }}
                    >
                      <canvas ref={canvasRef} width={200} height={46}></canvas>
                      <Button
                        sx={{ ml: isMobile ? 0 : 3, mt: isMobile ? 1 : "" }}
                        onClick={refreshCaptcha}
                        variant="outlined"
                      >
                        Refresh CAPTCHA
                      </Button>
                    </div>
                    <TextField
                      sx={{
                        width: isMobile ? "100%" : "50%",
                        alignSelf: "center",
                      }}
                      variant="outlined"
                      value={captchaInput}
                      onChange={(e) => setCaptchaInput(e.target.value)}
                      error={formSubmitted && !isCaptchaValid()}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        justifyItems: "center",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        checked={formData.Consent}
                        name="Consent"
                        onChange={handleFormChange}
                        required
                      />{" "}
                      <Typography>
                        Acord pentru preluarea datelor cu caracter personal
                      </Typography>{" "}
                    </div>{" "}
                    <Button
                      sx={{
                        width: isMobile ? "auto" : "36%",
                        mt: isMobile ? 2 : 3,
                        alignSelf: "center",
                      }}
                      variant="contained"
                      onClick={handleFormSubmit}
                    >
                      Trimite citirea
                    </Button>
                    <Typography
                      variant="body1"
                      sx={{ mt: 3, mb: 2, color: "#29348f" }}
                    >
                      Vă mulțumim pentru utilizarea acestui portal și vă
                      reamintim faptul că operatorul de distribuție are în
                      continuare obligația de a citi contorul de energie
                      electrică.
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ mt: 3, mb: 2, color: "#29348f" }}
                    >
                      Vă rugăm să permiteți în continuare accesul personalului
                      delegat pentru efectuarea citirii locale, la data
                      programată, chiar dacă ați transmis indexele prin acest
                      portal.
                    </Typography>
                  </FormControl>
                </div>
              </CardContent>
            </Card>
          </div>
        </>
      )}
    </div>
  );
};

export default Autocitiri;
